import parseDialogue from "../../util/parseDialogue";

export const TsumaraInitial = parseDialogue(`
tsumara:initial:100-300

#100 Welcome, consumer, to Network City, retailer for the new future net technologies, software for the here and beyond. 
>200 Hi.

#200 I am your automated host. Can I be of assistance?
>300 I'd like to purchase some software.
>0 No thanks.
`);
